const translations = {
    es: {
        // Filter labels
        "filters.downloadType": "Descarga",
        "filters.wasteType": "Fracción",
        "filters.groups": "Grupos",
        "filters.device_groups": "Grupos de dispositivo",
        "filters.zones": "Zonas",
        "filters.routes": "Rutas",
        "filters.islands": "Islas",
        "filters.date": "Fecha",

        // Button texts
        "filters.clearFilters": "Limpiar filtros",
        "filters.search": "Buscar",
        "filters.downloadCSV": "CSV",
        "filters.downloadExcel": "Excel",
        "filters.downloadExcelTitle": "Descargar Excel",
        "filters.clearDates": "Limpiar fechas",

        // Select options
        "filters.all": "Todos",

        // Results text
        "filters.found": "Encontrados: ",
        "filters.noData": "Sin Datos",
        "filters.pages": "Págs",
        "filters.total": "Tot",

        // Input labels
        "filters.containerUID": "UID - Contenedor",
        "filters.deviceUUID": "UUID - Dispositivo",
        "filters.fillLevel": "Nivel Llenado min-max",
        "filters.measure": "Medida",
        "filters.filling": "Llenado",

        // Input placeholders
        "filters.minimum": "minimo",
        "filters.maximum": "maximo",

        // Column headers for container list table
        "tables.uid": "UID",
        "tables.uuid": "UUID",
        "tables.model": "Modelo",
        "tables.serialNumber": "Número Serie",
        "tables.wasteType": "Fracción",
        "tables.downloadType": "Descarga",
        "tables.fillLevel": "Nivel",
        "tables.battery": "Batería",
        "tables.group": "Grupo",
        "tables.zone": "Zona",
        "tables.route": "Ruta",
        "tables.island": "Isla",
        "tables.status": "Estado",
        "tables.lastUpdate": "Ult. Medida",
        "tables.average": "Med",

        // Common texts
        "common.loading": "Cargando datos...",

        // Collections analysis table
        "tables.address": "Dirección",
        "tables.mediaContenedor": "Media Contenedor",
        "tables.mediaContenedorTitle": "Suma de medidas válidas / nº días con recogida",
        "tables.mediaLineal": "Media Llenado Lineal",
        "tables.mediaLinealTitle": "Suma de medidas válidas / nº días con recogida",
        "tables.daysToNextCollection": "Días para siguiente recogida",
        "tables.avgGap": "Gap medio",
        "tables.containerNum": "Cont",
        "tables.containerLabel": "Contenedor",
        "tables.dailyLevels": "Nivel de recogidas",
        "tables.anualCollections": "Recogidas año",
        "tables.savings": "Recogidas ahorradas",
        "tables.percentageSavings": "% Recogidas ahorradas",
        "tables.mediaSummary": "Media",
        "tables.mediaIsland": "Media Isla",
        "tables.mediaIslandTitle": "Suma de medidas válidas / nº días con recogida",
        "tables.totalSavingsBadge": "Ahorro total:",
        "tables.rangePctFill": "Rangos Porcentaje Llenado",
        "tables.pctContainer": "Porcentaje Cont.",
        "tables.containers": "Contenedores",
        "tables.totalSummary": "Totales",
        "tables.totalLabel": "TOTAL",

        // Input labels
        "inputs.collectionDays": "Dias de recogida",
        "inputs.targetPercentage": "% Recogida",
        "inputs.daysYear": "Dias año",

        // Tab titles
        "tabs.containers": "Contenedores",
        "tabs.islands": "Islas",
        "tabs.savingsContainers": "Ahorro Contenedores",
        "tabs.savingsIslands": "Ahorro Islas",
        "tabs.ranges": "Rangos",
        "tabs.dailies": "Llenado diario",
        "tabs.quarter": "Cuadrantes diarios",

        // Graph page
        "graph.title": "Histórico de contenedores",
        "graph.uuid": "UUID",
        "graph.zoom": "Zoom",
        "graph.statistics": "Estadísticas",
        "graph.minimum": "Mínimo",
        "graph.average": "Promedio",
        "graph.maximum": "Máximo",
        "graph.showMore": "Ver más",
        "graph.noData": "No hay datos disponibles",
    },
    en: {
        // Filter labels
        "filters.downloadType": "Download Type",
        "filters.wasteType": "Waste Type",
        "filters.groups": "Groups",
        "filters.device_groups": "Device groups",
        "filters.zones": "Zones",
        "filters.routes": "Routes",
        "filters.islands": "Islands",
        "filters.date": "Date",

        // Button texts
        "filters.clearFilters": "Clear filters",
        "filters.search": "Search",
        "filters.downloadCSV": "CSV",
        "filters.downloadExcel": "Excel",
        "filters.downloadExcelTitle": "Download Excel",
        "filters.clearDates": "Clear dates",

        // Select options
        "filters.all": "All",

        // Results text
        "filters.found": "Found: ",
        "filters.noData": "No Data",
        "filters.pages": "Pages",
        "filters.total": "Total",

        // Input labels
        "filters.containerUID": "Container UID",
        "filters.deviceUUID": "Device UUID",
        "filters.fillLevel": "Fill Level min-max",
        "filters.measure": "Measure",
        "filters.filling": "Filling",

        // Input placeholders
        "filters.minimum": "minimum",
        "filters.maximum": "maximum",

        // Column headers for container list table
        "tables.uid": "UID",
        "tables.uuid": "UUID",
        "tables.model": "Model",
        "tables.serialNumber": "Serial Number",
        "tables.wasteType": "Waste Type",
        "tables.downloadType": "Download Type",
        "tables.fillLevel": "Level",
        "tables.battery": "Battery",
        "tables.group": "Group",
        "tables.zone": "Zone",
        "tables.route": "Route",
        "tables.island": "Island",
        "tables.status": "Status",
        "tables.lastUpdate": "Last Update",
        "tables.average": "Avg",

        // Common texts
        "common.loading": "Loading data...",

        // Collections analysis table
        "tables.address": "Address",
        "tables.mediaContenedor": "Avg Container",
        "tables.mediaIsland": "Avg Island",
        "tables.mediaContenedorTitle": "Sum of valid measures / days with collection",
        "tables.mediaIslandTitle": "Sum of valid measures / days with collection",
        "tables.mediaLineal": "Avg Linear Fill",
        "tables.mediaLinealTitle": "Sum of valid measures / days with collection",
        "tables.daysToNextCollection": "Days to next collection",
        "tables.avgGap": "Avg Gap",
        "tables.containerNum": "Nº",
        "tables.containerLabel": "Container",
        "tables.dailyLevels": "Collection level",
        "tables.anualCollections": "Collections year",
        "tables.savings": "Collections saved",
        "tables.percentageSavings": "% Collections saved",
        "tables.mediaSummary": "Average",
        "tables.totalSavingsBadge": "Total savings:",
        "tables.rangePctFill": "Fill Percentage Ranges",
        "tables.pctContainer": "% Container",
        "tables.containers": "Containers",
        "tables.totalSummary": "Totals",
        "tables.totalLabel": "TOTAL",

        // Input labels
        "inputs.collectionDays": "Collection days",
        "inputs.targetPercentage": "% Collection",
        "inputs.daysYear": "Days year",

        // Tab titles
        "tabs.containers": "Containers",
        "tabs.islands": "Islands",
        "tabs.savingsContainers": "Savings Containers",
        "tabs.savingsIslands": "Savings Islands",
        "tabs.ranges": "Ranges",
        "tabs.dailies": "Dailies Filling",
        "tabs.quarter": "Daily Quarters",

        // Graph page
        "graph.title": "Container History",
        "graph.uuid": "UUID",
        "graph.zoom": "Zoom",
        "graph.statistics": "Statistics",
        "graph.minimum": "Minimum",
        "graph.average": "Average",
        "graph.maximum": "Maximum",
        "graph.showMore": "Show more",
        "graph.noData": "No data available",
    },
};

export default translations;
